<template>
  <div>
    <div v-if="externalSoftware !== 7" class="not-available">
      {{ $t('export.slovenianParttimeExport.notAvailable') }}
    </div>
    <div v-else class="has-header">
      <div class="header main">
        <div class="align-left">
          <dateselectionheader :label="dateDisplay" @PrevDate="modDate('sub')" @NextDate="modDate('add')" />
        </div>
        <div class="align-middle"><headerbuttonstack :state="headerButtons" /></div>
        <div class="align-right"></div>
      </div>
      <div class="scrollbar-container export">
        <labelc type="header title" :text="$t('export.slovenianParttimeExport.title')" />

        <div v-if="loading" class="loading-md bg" style="z-index: 20">
          <i class="fas fa-spinner"></i>
          <br />
          <div class="loading-text">
            {{ loadingText }}
          </div>
        </div>

        <div v-else-if="downloading" class="loading-md bg" style="z-index: 20">
          <i class="fas fa-spinner"></i>
          <br />
          <div class="loading-text">
            {{ $t('export.slovenianParttimeExport.downloading') }}
          </div>
        </div>

        <div v-else class="parentBox">
          <!-- Stores -->
          <div class="settings xColumn2">
            <datatablesimple style="flex-basis: calc(50% - 48px)" :state="settingsCompanyState" class="flex-item" />
          </div>

          <!-- Collective contracts -->
          <div class="settings xColumn2">
            <labelc
              type="header title"
              style="width: 100%"
              :text="$t('employee.collective.collectiveAgreements')"
            />
            <div
              class="panel-container"
              style="text-align: left"
            >
              <buttonc
                v-for="contract in collectiveContracts"
                :key="contract.id"
                :label="contract.name"
                @click="toggleCollectiveContract(contract.id)"
                v-bind:class="{ selected: collectiveContractIds.includes(contract.id) }"
                style="width: 254px; height: 30px; margin: 2.5px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createSlovenianExportHelper } from "./slovenian-export-helper";

export default {
  name: "ExportSlovenianParttime",
  mixins: [createSlovenianExportHelper({
    hideDetails: false,
    filenamePrefix: "parttime",
  })],
};
</script>

<style scoped>

.export {
  background: var(--bg);
  padding: 24px 0px 32px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
}
.export > .header {
  width: calc(100% + 24px);
  margin-left: -24px;
  padding-left: 28px;
  box-shadow: 0 2px 0px -1px var(--contrast-2);
  margin-bottom: 20px;
}
.settings {
  column-gap: 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  column-gap: 0px;
  margin-right: 24px;
}
.settings > .flex-item {
  flex: 0 1 calc(50%); /* don't shrink, can grow */
  max-width: 800px;
  min-width: 650px; /* damit nicht zu früh auf eine Spalte reduziert wird */
}
.not-available { font-size: 22px; font-weight: bold; padding: 60px; }
.selection-actions { display: flex; gap: 14px; justify-content: center; }
.selection-actions a { cursor: pointer; }
.loading-state { padding: 25px; }
.export-action { clear: both; padding: 25px 0; display: flex; justify-content: flex-end; align-items: center; gap: 15px; }
</style>
